var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-12",attrs:{"cols":"12"}},[_c('v-alert',{staticClass:"text-center",attrs:{"type":"info"}},[_c('v-icon',{staticClass:"mr-4",attrs:{"x-large":""}},[_vm._v("mdi-link-off")]),_vm._v(" "+_vm._s(_vm.$t("not-found-msg", { url: this.$route.path }))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }